<template>
  <div>
    <LoadingPage v-if="loadingData"></LoadingPage>
    <v-container v-if="!loadingData" fluid>
      <v-row>
        <v-col
          v-for="article in articles"
          :key="article.id"
          class="d-flex child-flex pa-0"
          cols="4"
        >
          <div @click="articleClickHandler(article.id)" style="cursor: pointer">
            <v-card outlined color="transparent">
              <v-responsive :aspect-ratio="1" :min-height="thumbnailSize">
                <MediaComponent
                  :media="article.infopairs[0].media"
                  :slot-width="thumbnailSize"
                  :slot-height="thumbnailSize"
                  thumbnail
                ></MediaComponent>

                <v-sheet
                  class="text-caption white--text font-weight-bold pa-1"
                  style="position:absolute;margin-left:auto;margin-right:auto;left: 0;right: 0;bottom:0; text-align: start;z-index: 4;background-color:rgba(0, 0, 0, 0.7);"
                >{{ article.title }}</v-sheet>
              </v-responsive>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import APIService from '@/apiservices/APIService.js'
import LoadingPage from '@/components/LoadingPage.vue'
import MediaComponent from '@/components/MediaComponent.vue'
import { vueWindowSizeMixin } from 'vue-window-size'
export default {
  components: {
    MediaComponent,
    LoadingPage
  },

  mixins: [vueWindowSizeMixin],
  computed: {
    thumbnailSize() {
      return this.windowWidth > 900 ? 298 : Math.round(this.windowWidth / 3) - 1
    }
  },
  data() {
    return {
      articles: [],
      loadingData: false
    }
  },

  created() {
    this.loadingData = true
    APIService.getArticleTitles({ category: 5 }) // 5 - Питер
      .then(({ data }) => {
        this.articles = data
        this.loadingData = false
      })
      .catch(error => {
        console.log('There was an error in getArticleTitles API call:', error)
      })
  },
  methods: {
    articleClickHandler(articleId) {
      this.$router.push('/article/' + articleId)
    }
  }
}
</script>

<style></style>
